export interface SkinCategory {
  active?: boolean;
  image: string;
  label: string;
  status?: string;
  subtitle: string;
  type: string;
}

export interface SkinGame {
  badge?: string;
  image: string;
  provider: string;
  title: string;
  type: string;
}

export interface SkinCampaign {
  accent: string;
  // 成品运营图已包含文案和按钮，前端只负责轮播与跳转。
  artworkOnly?: boolean;
  cta: string;
  eyebrow: string;
  image?: string;
  key: string;
  reward: string;
  subtitle: string;
  title: string;
  to: string;
  visuals?: string[];
}

export interface SkinChests {
  /** 已达标可领取：金光宝箱 */
  claimable: string;
  /** 未达标锁定：灰色挂锁宝箱 */
  locked: string;
  /** 已领取：开盖宝箱 */
  opened: string;
}

export interface SkinManifest {
  assets: {
    avatar: string;
    chests: SkinChests;
    hero: string;
    logo: string;
    pixQr: string;
  };
  brandName: string;
  campaigns: SkinCampaign[];
  categories: SkinCategory[];
  code: string;
  games: SkinGame[];
}

const skinRoot = '/skins/orange-sports';

export const orangeSportsSkin: SkinManifest = {
  assets: {
    avatar: `${skinRoot}/avatars/player.png`,
    chests: {
      claimable: `${skinRoot}/activities/chest-claimable.png`,
      locked: `${skinRoot}/activities/chest-locked.png`,
      opened: `${skinRoot}/activities/chest-opened.png`,
    },
    hero: `${skinRoot}/banners/home-hero.png`,
    logo: `${skinRoot}/brand/logo.png`,
    pixQr: `${skinRoot}/payments/pix-qr.png`,
  },
  brandName: 'PZ Play Zone',
  campaigns: [
    {
      accent: 'orange',
      cta: 'Depositar com Pix',
      eyebrow: 'Fim de semana',
      image: `${skinRoot}/banners/campaign-weekend-pix.png`,
      key: 'weekend-pix',
      reward: 'Até R$ 500',
      subtitle: 'Futebol ao vivo, cassino e 50 rodadas grátis.',
      title: 'É jogo e diversão',
      to: '/deposit',
    },
    // 以下三个运营位映射活动引擎真实活动：图保留，文案与跳转指向活动详情
    {
      accent: 'gold',
      cta: 'Abrir prêmio',
      eyebrow: 'Bônus de novato',
      image: `${skinRoot}/banners/campaign-mystery-newbie.png`,
      key: 'mystery-newbie',
      reward: 'Até R$ 888',
      subtitle: 'Deposite nos primeiros dias e abra prêmios surpresa.',
      title: 'Prêmio misterioso',
      to: '/activities/mystery-newbie',
      visuals: [`${skinRoot}/games/fortune-tiger.png`, `${skinRoot}/games/dragon-slots.png`],
    },
    {
      accent: 'green',
      cta: 'Conferir recompensa',
      eyebrow: 'Todo dia 7',
      image: `${skinRoot}/banners/campaign-member-day.png`,
      key: 'member-day',
      reward: 'Até R$ 100',
      subtitle: 'Recompensa pelo seu depósito do mês passado.',
      title: 'Apreciação aos membros',
      to: '/activities/member-day',
      visuals: [`${skinRoot}/games/aviator-x.png`, `${skinRoot}/games/sweet-bonanza.png`],
    },
    {
      accent: 'violet',
      cta: 'Depositar agora',
      eyebrow: 'Quarta de jogo',
      image: `${skinRoot}/banners/campaign-deposit-wed.png`,
      key: 'deposit-wed',
      reward: 'Até R$ 100',
      subtitle: 'Deposite na quarta-feira e ganhe bônus extra.',
      title: 'Bônus de depósito',
      to: '/activities/deposit-bonus-wed',
      visuals: [`${skinRoot}/games/olympus-gold.png`, `${skinRoot}/games/coelho-da-sorte.png`],
    },
  ],
  categories: [
    {
      active: true,
      image: `${skinRoot}/categories/slots.png`,
      label: 'Slots',
      subtitle: '320 jogos',
      type: 'slot',
    },
    {
      image: `${skinRoot}/categories/live.png`,
      label: 'Ao vivo',
      subtitle: '64 mesas',
      type: 'live_casino',
    },
    {
      image: `${skinRoot}/categories/crash.png`,
      label: 'Crash',
      subtitle: '18 jogos',
      type: 'crash',
    },
    {
      image: `${skinRoot}/categories/table.png`,
      label: 'Mesa',
      subtitle: '42 jogos',
      type: 'table',
    },
    {
      image: `${skinRoot}/categories/sports.png`,
      label: 'Esportes',
      status: 'Ao vivo',
      subtitle: 'Ao vivo',
      type: 'sportsbook',
    },
    {
      image: `${skinRoot}/categories/new.png`,
      label: 'Novos',
      subtitle: '36 novos',
      type: 'new',
    },
  ],
  code: 'orange-sports',
  games: [
    {
      badge: 'POPULAR',
      image: `${skinRoot}/games/fortune-tiger.png`,
      provider: 'PG Soft',
      title: 'Fortune Tiger',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/dragon-slots.png`,
      provider: 'Pragmatic Play',
      title: 'Dragon Slots',
      type: 'slot',
    },
    {
      badge: 'NOVO',
      image: `${skinRoot}/games/sweet-bonanza.png`,
      provider: 'Pragmatic Play',
      title: 'Sweet Bonanza',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/aviator-x.png`,
      provider: 'Spribe',
      title: 'Aviator X',
      type: 'crash',
    },
    {
      image: `${skinRoot}/games/coelho-da-sorte.png`,
      provider: 'BGaming',
      title: 'Coelho da Sorte',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/olympus-gold.png`,
      provider: 'Pragmatic Play',
      title: 'Olympus Gold',
      type: 'slot',
    },
  ],
};
